import { types, type Instance } from 'mobx-state-tree';

import { JOB_APPLICATION_TAB } from 'src/constants/tabs';

import { BUCKETS } from './types';

const JobApplicationUiStore = types.model('JobApplicationUiStore', {
  positionId: types.optional(types.number, -1),
  bucket: types.optional(
    types.enumeration<BUCKETS | ''>('Buckets', Object.values(BUCKETS)),
    BUCKETS.INBOX,
  ),
  page: types.optional(types.number, 1),
  selectedProspectId: types.optional(types.string, ''),
  talentSearch: types.optional(types.boolean, false),
  search: types.optional(types.string, ''),
  tab: types.optional(
    types.enumeration<JOB_APPLICATION_TAB>(
      'Tab',
      Object.values(JOB_APPLICATION_TAB),
    ),
    JOB_APPLICATION_TAB.RESUME,
  ),
});

export type IJobApplicationUiStore = Instance<typeof JobApplicationUiStore>;

export default JobApplicationUiStore;
